export default "/static/images/build_middle_3.png?8b54cec351a7c335b6749ec875863e33";